import type { ServiceFilters } from '../types';
import { companyKeys } from '@/features/companies';

export const serviceKeys = {
  all: ['services'] as const,
  lists: () => [...serviceKeys.all, 'list'] as const,
  list: (filters: MaybeRef<ServiceFilters>) =>
    [...serviceKeys.lists(), filters] as const,
  popularList: () => [...serviceKeys.lists(), 'popular'] as const,
  details: () => [...serviceKeys.all, 'detail'] as const,
  detail: (idOrSlug: MaybeRef<number | string>) =>
    [...serviceKeys.all, 'detail', idOrSlug] as const,
};

export const masterServiceKeys = {
  all: ['masters', 'services'] as const, // FIXME: do something with it
  lists: () => [...masterServiceKeys.all, 'list'] as const,
  list: (masterId: MaybeRef<number>, filters: MaybeRef<ServiceFilters>) =>
    [...masterServiceKeys.lists(), masterId, filters] as const,
  additionalList: (masterId: MaybeRef<number>, serviceId: MaybeRef<number>) =>
    [...masterServiceKeys.lists(), masterId, 'additional', serviceId] as const,
  detail: (
    masterId: MaybeRef<number>,
    serviceIdOrSlug: MaybeRef<number | string>
  ) => [...masterServiceKeys.all, 'detail', masterId, serviceIdOrSlug] as const,
};

export const workPlaceServiceKeys = {
  all: ['masters', 'work-place-services'] as const, // FIXME: do something with it
  lists: () => [...workPlaceServiceKeys.all, 'list'] as const,
  list: (workPlaceId: MaybeRef<number>, filters: MaybeRef<ServiceFilters>) =>
    [...workPlaceServiceKeys.lists(), workPlaceId, filters] as const,
  detail: (
    workPlaceId: MaybeRef<number>,
    serviceIdOrSlug: MaybeRef<number | string>
  ) =>
    [
      ...workPlaceServiceKeys.all,
      'detail',
      workPlaceId,
      serviceIdOrSlug,
    ] as const,
  parameterList: (workPlaceId: MaybeRef<number>, serviceId: MaybeRef<number>) =>
    [
      ...workPlaceServiceKeys.lists(),
      'parameters',
      workPlaceId,
      serviceId,
    ] as const,
};

export const companyServiceKeys = {
  all: (companyId: MaybeRef<number>) =>
    [...companyKeys.detail(companyId), 'services'] as const,
  list: (companyId: MaybeRef<number>) =>
    [...companyServiceKeys.all(companyId), 'list'] as const,
  detail: (
    companyId: MaybeRef<number>,
    serviceIdOrSlug: MaybeRef<number | string>
  ) =>
    [...companyServiceKeys.all(companyId), 'detail', serviceIdOrSlug] as const,
  parameterList: (companyId: MaybeRef<number>, serviceId: MaybeRef<number>) =>
    [
      ...workPlaceServiceKeys.lists(),
      'parameters',
      companyId,
      serviceId,
    ] as const,
};
